import Emploi from '@/generated/classes/Emploi';
export default class EmploiExtend extends Emploi {
  constructor() {
    super();
  }
}
